/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./FilterBaseView',
	'../../features/featuresHelper/DateTimeHelper',
	'../../widgets/livewidget/nls/StringResources'
],
function(View, DateTimeHelper, StringResources) {
	'use strict';

	var DateTimeFilterView = View.extend({
		reactViewClass: 'FullDateTimeFilter',
		compactReactViewClass: 'CompactDateTimeFilter',

		init: function() {
			DateTimeFilterView.inherited('init', this, arguments);
		},

		_getCommonViewProps: function() {
			var currentValues = this.model.toJSON();
			/* We use the current date/time when we can't tell the to/from values on initialization.
			   For example, if the datetime item is a property or static item, we can't
			   tell the to/from value, so default to today's date.*/
			var _now =  DateTimeHelper.getISOString(new Date());
			var props = {
				title: currentValues.name,
				actionTitle: StringResources.get('filter'),
				dataType: (this.options.dataType || 'datetime'), // 'date', 'time', 'datetime' Tells the control if it is to enable editing of date, time or both
				rangeType: currentValues.rangeType, //"after", "before", "between", "not between"
				fromValue: currentValues.from ||  _now, //String in UTC format.  dataType controls whether it uses the date part, time part or both.
				toValue: currentValues.to ||  _now, //String in UTC format.  dataType controls whether it uses the date part, time part or both.
				inverted: currentValues.inverted,
				filterSelectionType: 'range',
				locale: this.locale,
				timezone: this.timeZoneID,
				totalValues: 2,
				allowSwitch: false,
				allowIncludeNulls: false,
				loading: this.loading
			};
			return props;
		},

		_getCommonViewCallbacks: function() {
			return {
				onClear: this._onClear.bind(this),
				onChange: this._onChange.bind(this),
				onApply: this._onApply.bind(this),
				onClose: this._onClose.bind(this),
				onDone: this._onDone.bind(this)
			};
		}
	});
	return DateTimeFilterView;
});
